export default __webpack_public_path__ + "static/media/city-select.84e0115c.png";